// components/ParamsCard/DownloadReportModal.tsx
import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import DashboardContext from '@/contexts/DashboardContext';
import { Button } from '@hydrodigital/design-system';

interface DownloadReportModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDownload: () => void;
}

const DownloadReportModal = ({
  isOpen,
  onClose,
  onDownload,
}: DownloadReportModalProps) => {
  const { value: context } = React.useContext(DashboardContext);

  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-40"
        role="button"
        tabIndex={0}
        onClick={onClose}
      />
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="text-center bg-white shadow-lg rounded-lg p-4 text-gray-800 border border-gray-200 relative w-full max-w-xs">
          <button
            className="absolute top-2 right-2 p-1 hover:bg-gray-100 rounded-full"
            role="button"
            tabIndex={0}
            onClick={onClose}
          >
            <CloseOutlined className="text-sm text-gray-600" />
          </button>

          <div className="text-sm font-semibold mb-2">
            The selected date range is
          </div>

          <div className="text-sm mb-4">
            <span>
              {dayjs(context.selectedDate[0]).format('YYYY/MM/DD - hh:mm a')}
            </span>
            <br />
            <span>
              <b>to</b>
            </span>
            <br />
            <span>
              {dayjs(context.selectedDate[1]).format('YYYY/MM/DD - hh:mm a')}
            </span>
          </div>

          <Button className="w-full" variant="primary" onClick={onDownload} label="Accept" showIcon={false} />
        </div>
      </div>
    </>
  );
};

export default DownloadReportModal;
